import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { APPROVE_STATUS_R, SOURCE_QUEUE } from "constants/FormatDataContanst";
import moment from "moment";
import React from "react";
import { useLocation } from "react-router-dom";
import { BU_STORE_HEADER } from "store/auth/login/actionTypes";

export const errorMessage = error => {
  const message =
    error.response && error.response.data
      ? error.response.data
      : { message: error.message };
  console.log("🚀 ~ file: utils.js:6 ~ errorMessage ~ errorMessage:", message);
  return { ...message };
};

export const formatTaxCode = value => {
  return value;
  // let finalValue = value;
  // if (value.length === 13) {
  //   const char = "-";
  //   const position = 10;
  //   finalValue = [
  //     finalValue.slice(0, position),
  //     char,
  //     finalValue.slice(position),
  //   ].join("");
  // }
  // return finalValue;
};

export const base64toBlob = data => {
  const base64WithoutPrefix = data.substr(
    "data:application/pdf;base64,".length
  );
  const bytes = atob(base64WithoutPrefix);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: "application/pdf" });
};

export const convertDate = (data, format = "") => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    if (format === "date") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${ye}-${mo}-${da}`;
    } else if (format === "label") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${da}/${mo}/${ye}`;
    } else {
      date = Math.round(new Date(data).getTime() / 1000);
    }
  } else {
    date = data;
  }
  return date;
};

export const convertToDD_MM_YYY = (input, symbol = "/") => {
  const datePart = input.match(/\d+/g),
    year = datePart[0], // get only two digits
    month = datePart[1],
    day = datePart[2];

  return day + symbol + month + symbol + year;
};

export const numberWithCommas = (nStr, isShow) => {
  if (nStr) {
    let dau = "";
    if (isShow) {
      dau = nStr > 0 ? "+" : "";
    }
    nStr += "";
    const x = nStr.split(".");
    let x1 = x[0];
    const x2 = x.length > 1 ? "." + x[1] : "";
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return dau + x1 + x2;
  }
  return "";
};

export const downloadToolUsbToken = () => {
  const link = document.createElement("a");
  link.href = `https://inv.4si.vn/tools/4si_signer_windows.zip`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const toastWarningIsAllStore = addToast => {
  const buStoreHeader = localStorage.getItem(BU_STORE_HEADER);
  if (buStoreHeader === ALL_STORE) {
    addToast("Vui lòng chọn đơn vị cụ thể cần thao tác", {
      appearance: "error",
      autoDismiss: true,
    });
    return true;
  }
  return false;
};

export const getFileNameExcel = fileName => {
  const date = moment(new Date()).format("DD_MM_YYYY");
  return fileName + "_" + date + ".xlsx";
};

export const toastNoRowSelect = (addToast, t) => {
  addToast("Vui lòng chọn dòng cần thao tác", {
    appearance: "warning",
    autoDismiss: true,
  });
};

export const useQueryRouter = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const getDefaultValueFilter = (
  loadDefaultFilter = false,
  key,
  dataDefaultFilter
) => {
  const filterValue = dataDefaultFilter?.filterValue[key];
  if (!filterValue) return undefined;
  let data = null;
  switch (filterValue?.filterType) {
    case "TEXT":
      data = filterValue?.value;
      break;
    case "SELECT":
      data = filterValue?.value;
      break;
    case "CUSTOM_DATE_FILTER_TABLE_TYPE":
      data = {
        comparator: filterValue?.value?.comparator,
        value: filterValue?.value?.date,
      };
    default:
      break;
  }
  return loadDefaultFilter ? data : undefined;
};

export const getDefaultQueryFilter = dataDefaultFilter => {
  return dataDefaultFilter?.filterQuery;
};

export const BU_CONFIG = {
  INVOICE_POS: "can_pos", // Check quyền ẩn hiện HĐ từ MTT
};

export const checkIsHaveInvoicePos = (
  buTenantHeaderInfo,
  finalBuInfo,
  buStoreHeader,
  tenantCodeHeader,
  listBuOfTenant
) => {
  if (!buStoreHeader || !tenantCodeHeader) {
    return false;
  }
  if (
    buStoreHeader === ALL_BU &&
    listBuOfTenant?.filter(b => b.value !== "ALL_BU")?.every(obj => obj.can_pos)
  ) {
    return true;
  }
  const check = buTenantHeaderInfo?.[BU_CONFIG.INVOICE_POS]
    ? true
    : finalBuInfo?.[BU_CONFIG.INVOICE_POS]
    ? true
    : false;
  return check;
};

export const checkIsAllowForPendingBills = i => {
  let isAllowForPendingBills = true;
  //
  if (i.approve_status === APPROVE_STATUS_R) {
    if (i.group_ref_no) {
      isAllowForPendingBills = false;
    } else if (!i.client_ref_uuid && i.source === SOURCE_QUEUE.QUEUE) {
      isAllowForPendingBills = false;
    }
  }
  return isAllowForPendingBills;
};
